import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "app-pagination",
    templateUrl: "./pagination.component.html",
    styleUrls: ['./pagination.component.css']
})

export class PaginationComponent{
    constructor(){

    }

    @Input('pageSize') pageSize: number;
    @Input('currentPage') currentPageP: number;
    @Input('totalCount') totalCount: number;
    @Output('onPreviousNextClick') onPreviousNextClick = new EventEmitter();

    noOfPages: number = 0;
    currentPage: number = 0;

    ngOnInit(){
        this.preProcess();
    }

    ngOnChanges(){
        this.preProcess();
    }

    preProcess(){
        if(!this.currentPageP){
            this.currentPage = 0;
        }else{
            this.currentPage = this.currentPageP;
        }
        if (this.totalCount != 0) {
            this.noOfPages = Math.ceil(this.totalCount / this.pageSize);
        } else {
            this.noOfPages = 1;
        }
    }

    previousClick(){
        this.currentPage--;
        this.onPreviousNextClick.emit(this.currentPage);
    }

    nextClick(){
        this.currentPage++;
        this.onPreviousNextClick.emit(this.currentPage);
    }

}